
<div class="card pt-0 mb-5">

    <div class="card-body">
      <form (ngSubmit)="onSubmit(merchantMDRform.value)" [formGroup]="merchantMDRform" appBlockCopyPaste>
        <div>
          <div class="row">
            <div class="col-sm-12">
              <div class="mb-3">
                <label class="form-label">Merchant Id <span aria-hidden="true" class="symbol required" style="color:red;">*</span></label>

                <ng-select formControlName="merchantId" (keyup.enter)="loadDatabyMid()" (click)="loadDatabyMid()"
                  placeholder="merchantId">
                  <ng-option *ngFor="let merchant of Resultdata" [value]="merchant.MerchantId">
                    {{merchant.merchant_name}} ({{merchant.MerchantId}})
                  </ng-option>
                </ng-select>
  
  
              </div>
            </div>
          </div>
                <div class="row">
                  <div class="col-sm-4">
                    <div class="mb-3">
                      <label class="form-label">Service Provider <span aria-hidden="true" class="symbol required" style="color:red;">*</span></label>
                      <select class="form-select" aria-label="Default select example" formControlName="spId"
                        (change)="seletservice($event)" [ngClass]="{'is-invalid': isForm1Submitted && form1.spId.errors}">
                        <option value="" class="drop">Select Service Provider</option>
                        <option *ngFor="let service of Resdata" [value]="service.FieldValue">
                          {{service.FieldText}}</option>
                      </select>

                    </div>
                  </div><!-- Col -->
                  <div class="col-sm-4">
                    <div class="mb-3">
                      <label class="form-label">Instrument <span aria-hidden="true" class="symbol required" style="color:red;">*</span></label>
                      <select class="form-select" aria-label="Default select example" formControlName="instrument_id"
                        (change)="selectinstrument($event)"
                        [ngClass]="{'is-invalid': isForm1Submitted && form1.instrument_id.errors}">
                        <option value="" class="drop" disabled selected>Select Instrument</option>
                        <option [disabled]="!(Instrumentselect)" *ngFor="let instrument of Resdatas"
                          [value]="instrument.FieldValue">
                          {{instrument.FieldText}}</option>
                      </select>
                      <!-- <div *ngIf="isForm1Submitted && form1.instrument_id.errors?.required"
                          class="invalid-feedback">
                          Please fill this field
                      </div> -->
                    </div>
                  </div>
                  <!-- Col -->
  
                  <div class="col-sm-4">
                    <div class="mb-3">
                      <label class="form-label">Bank Selection <span aria-hidden="true" class="symbol required" style="color:red;">*</span></label>
                      <select class="form-select form-control" aria-label="Default select example"
                        formControlName="bank_id" [ngClass]="{'is-invalid': isForm1Submitted && form1.bank_id.errors}">
                        <option value="" class="drop">Select Bank</option>
                        <option [disabled]="!(bankselect)" *ngFor="let bank of Resbank" [value]="bank.FieldValue">
                          {{bank.FieldText}}
                        </option>
                      </select>
                      <!-- <div *ngIf="isForm1Submitted && form1.bank_id.errors?.required"
                          class="invalid-feedback">
                          Please fill this field
                      </div> -->
                    </div>
                  </div>
                  <!-- Col -->
                </div>
                <div class="row">
                  <div class="col-sm-4">
                    <div class="mb-3">
                      <label class="form-label">Instrument Brand <span aria-hidden="true" class="symbol required" style="color:red;">*</span></label>
                      <select class="form-select" aria-label="Default select example" formControlName="instrumentBrand"
                        [ngClass]="{'is-invalid': isForm1Submitted && form1.instrumentBrand.errors}">
                        <option value="">Select Instrument Brand</option>
                        <option *ngFor="let instruments of ResinstrumentBrand" [value]="instruments.FieldText">
                          {{instruments.FieldValue}}</option>
                      </select>
                      <!-- <div *ngIf="isForm1Submitted && form1.spId.errors?.required" class="invalid-feedback">
                          Please fill this field
                      </div> -->
                    </div>
                  </div><!-- Col -->
                  <div class="col-sm-4">
                    <div class="mb-3">
                      <label class="form-label">Status <span aria-hidden="true" class="symbol required" style="color:red;">*</span></label>
                      <select class="form-select form-control" aria-label="Default select example"
                        formControlName="status" [ngClass]="{'is-invalid': isForm1Submitted && form1.status.errors}">
                        <option value="" disabled class="drop">Select Status</option>
                        <option *ngFor="let bank of Resbank" [value]="bank.FieldValue">
                          {{bank.FieldText}}
                        </option>
                      </select>
                      <!-- <div *ngIf="isForm1Submitted && form1.status.errors?.required"
                          class="invalid-feedback">
                          Please fill this field
                      </div> -->
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="mb-3">
                      <label class="form-label">Remark <span aria-hidden="true" class="symbol required" style="color:red;">*</span></label>
                      <input type="text" autocomplete="new-password"  maxlength="50" class="form-control" placeholder="Remark" formControlName="remark"
                        [ngClass]="{'is-invalid': isForm1Submitted && form1.remark.errors}">
                      <!-- <div *ngIf="isForm1Submitted && form1.remark.errors?.required"
                          class="invalid-feedback">
                          Please fill this field
                      </div> -->
                    </div>
                  </div>
                </div>
  
              <!-- </ng-template> -->
<!--   
            </ngb-panel>
  
  
          </ngb-accordion> -->
  
  
        </div>
        <div class="row mb-2">
          <div class="col-md-10"></div>
          <div class="col-md-2">
            <!--          <div class="text-end">-->
            <button type="submit" class="form-control btn btn-primary pull-right mt-3"
              [disabled]="!(this.permissions.includes('Add') || this.permissions.includes('Edit'))">Add New
            </button>
            <!--          </div>-->
          </div>
        </div>
      </form>
  
    </div>
  </div>
  
  <div class="row">
    <div class="col-xl-10 main-content">
      <button (click)="onExportCSV()" class="btn btn-light" type="button">Export CSV<i class="feather icon-download"></i>
      </button>
  
      <div class="btn-group" ngbDropdown role="group">
        <button class="btn btn-primary" ngbDropdownToggle>Columns</button>
        <div ngbDropdownMenu class="ng-dropdown-panel-items p-1"
          style="height: 250px;width: 250px; overflow: scroll; scroll-behavior: smooth">
          <div class="form-group">
            <!--            <label for="columns" class="form-label"> All Columns <span aria-hidden="true" class="symbol required" style="color:red;">*</span></label>-->
            <div *ngIf="columnDefs" class="list-group ng-option">
              <span *ngFor="let column of columnDefs; let i = index" class="checkbox">
                <label class="list-group-item p-2">
                  <input class="form-check-input me-1" type="checkbox" value="{{i}}" name="{{column.headerName}}"
                    (change)="updateSelectedTimeslots($event)"
                    [checked]="(tableSelectedColumn && (-1 !==tableSelectedColumn.indexOf(column)) ? 'checked': '')">
                  {{column.field | uppercase }}
                 <span aria-hidden="true" class="symbol required" style="color:red;">*</span></label>
              </span>
            </div>
  
          </div>
  
  
        </div>
      </div>
  
      <!-- <div class="btn-group mb-1 mb-md-0">
        <button class="btn btn-primary" type="button">Columns</button>
        <div class="btn-group" ngbDropdown role="group">
          <button class="btn btn-primary dropdown-toggle-split" ngbDropdownToggle></button>
          <div ngbDropdownMenu>
            <ng-select [(ngModel)]="tableSelectedColumn" [closeOnSelect]="false" [items]="columnDefs"
                       [multiple]=true bindLabel="field">
              <ng-template let-index="index" let-item="item" let-item$="item$" ng-option-tmp>
                <input [ngModel]="item$.selected" id="item-{{index}}" type="checkbox"/>
                {{item.field.toUpperCase()}}
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div> -->
  
  
    </div>
    <div class="col-xl-2" *ngIf="this.permissions.includes('View')">
      <input [(ngModel)]="globalSearch" [ngbTypeahead]="search" class="form-control" id="typeahead-basic"
        placeholder="Search" type="text" autocomplete="new-password" />
    </div>
  </div>
  
  <div class="row" style="min-height: 500px">
    <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine">
      <ag-grid-angular [enableCellTextSelection]=true (filterChanged)="onFilterChange($event)" (filterModified)="onFilterModified($event)"
        (filterOpened)="onFilterOpened($event)" (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)"
        (rowDoubleClicked)="onRowDoubleClicked($event)" [columnDefs]="tableSelectedColumn" [defaultColDef]="defaultColDef"
        [paginationPageSize]="pageSize" [pagination]="true" [rowData]="rowData" [rowModelType]=""
        [rowSelection]="'single'" [suppressPaginationPanel]="true" class="ag-theme-alpine"
        style="width: 100%; height: auto;">
      </ag-grid-angular>
    </div>
  </div>
  
  
  <div class="row bg-white p-2 mt-0">
    <div class="col-md-4">
      <select (change)="onPageSizeChanges($event)" [(ngModel)]="pageSize"
        class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
        <option [ngValue]="10">10</option>
        <option [ngValue]="20">20</option>
        <option [ngValue]="30">30</option>
      </select>
    </div>
  
    <div class="col-md-8">
      <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="currentPage" [boundaryLinks]="true"
        [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageSize" [rotate]="true"
        class="d-flex justify-content-end col-8 align-right">
      </ngb-pagination>
    </div>
  
  </div>